import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { BreakTypeStateClass } from './interfaces/breakTypeStateClass'
const initialState: BreakTypeStateClass = {
    isLoading: false,
    status: 'idle',
    breakTypeList: [],
    selectedRecord: {},
    isReload: false
}
interface IThunkApi {
    state: {
        breakType: BreakTypeStateClass;
    },
}
export const getAccountBreakTypesAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'breakType/getAccountBreakTypes',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/BreakType', 'Get', '', true, '02c8675f-648f-4c76-8fcc-73d02e69df21');
            const json = await response.json();
            return json;
        }
    )

export const getAccountBreakTypeByAccountBreakTypeIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'breakType/getAccountBreakTypeByAccountBreakTypeId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/BreakType/GetDataByAccountBreakTypeId/' + arg, 'Get', '', true, '02c8675f-648f-4c76-8fcc-73d02e69df21');
            const json = await response.json();
            return json;
        }
    )

export const addAccountBreakTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'breakType/addAccountBreakType',
        async (arg, thunkApi) => {
            const { BreakType } = arg;
            const response = await fetchAPI('api/BreakType/', 'POST', { BreakType }, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const updateAccountBreakTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'breakType/updateAccountBreakType',
        async (arg, thunkApi) => {
            const { AccountBreakTypeId, BreakType, IsDisabled } = arg;
            const response = await fetchAPI('api/BreakType/' + AccountBreakTypeId, 'POST', { BreakType, IsDisabled }, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountBreakTypeAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'breakType/deleteAccountBreakType',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/BreakType/' + arg, 'DELETE', '', true, '02c8675f-648f-4c76-8fcc-73d02e69df21');
            const json = await response.json();
            return json;
        }
    )

export const breakTypeSlice = createSlice({
    name: 'breakType',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountBreakTypesAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBreakTypesAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                //console.log('getAccountBreakTypesAsync.fulfilled', payload);
                state.breakTypeList = payload;
                state.isReload = false;
                state.selectedRecord = {};
            })
            .addCase(getAccountBreakTypesAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAccountBreakTypeByAccountBreakTypeIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountBreakTypeByAccountBreakTypeIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                console.log('getAccountBreakTypeByAccountBreakTypeIdAsync.fulfilled', payload);
                state.selectedRecord = payload[0];
            })
            .addCase(getAccountBreakTypeByAccountBreakTypeIdAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountBreakTypeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountBreakTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                // console.log('addAccountBreakTypeAsync.fulfilled', payload);
                // state.breakTypeList.push(payload);
                state.isReload = true;
            })
            .addCase(addAccountBreakTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(updateAccountBreakTypeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountBreakTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                // console.log('updateAccountBreakTypeAsync.fulfilled', payload);
                // const { AccountBreakTypeId } = payload;
                // const index = state.breakTypeList.findIndex((record) => record.AccountBreakTypeId === AccountBreakTypeId);
                // const newArray = [...state.breakTypeList];
                // newArray[index] = payload;
                // state.breakTypeList = newArray;
                state.isReload = true;
            })
            .addCase(updateAccountBreakTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountBreakTypeAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountBreakTypeAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                // console.log('deleteAccountBreakTypeAsync.fulfilled', payload);
                // const { AccountBreakTypeId } = payload;
                // state.status = 'idle';
                // const updatedDataList = state.breakTypeList.filter(c => c.AccountBreakTypeId !== AccountBreakTypeId);
                // console.log('updatedDataList', updatedDataList);
                // state.breakTypeList = updatedDataList;
                state.isReload = true;
            })
            .addCase(deleteAccountBreakTypeAsync.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const {
    resetSelectedRecordObjectInState
} = breakTypeSlice.actions
export const BreakTypeState = (state: RootState) => state.breakType
export default breakTypeSlice.reducer
